import { loadStripe } from '@stripe/stripe-js/pure'
import { STRIPE_ID } from 'constants/sdkConstants'

loadStripe.setLoadParameters({ advancedFraudSignals: false })
export const stripeSdk = loadStripe(STRIPE_ID)
